import styled from 'styled-components'
import TabLink from './TabLink'

export default styled(TabLink).attrs({
  as: 'a',
})`
  cursor: pointer;
`
